import React from 'react';
import CompleteStepIcon from '../../../../assets/icons/CompleteStepIcon.svg?react';
import CurrentStepIcon from '../../../../assets/icons/CurrentStepIcon.svg?react';
import InactiveStepIcon from '../../../../assets/icons/InactiveStepIcon.svg?react';
import { useAddCaseFormContext } from '../../../../contexts/AddCaseFormContext';
import { STEP_LABELS } from '../../../../constants/formSteps';
import { TOUR_TARGETS } from '../../../../constants/tourTargets';
import GenerateDemandBtn from '../../../../components/ui-control/GenerateDemandBtn';

const steps = Object.values(STEP_LABELS);

const stepperProgressClasses =
    "pb-7.5 mx-4 flex items-center border-b border-border-light";

// Left-packed, the way the Arches stepper reads: the steps sit together and the
// Next action keeps the far right, rather than the steps spanning the bar.
const stepperClasses =
    "flex items-center relative gap-2.5";

const stepClasses =
    "flex flex-row items-center text-center text-label text-base gap-2.5 " +
    "[&_span]:text-subtle";

const stepActiveClasses = "[&_span]:text-content! [&_span]:font-semibold";

// A short hairline dash between steps, not a bar stretched across the gap.
// max-w caps it at the Arches 24px while still letting it shrink when narrow.
const lineClasses = "grow max-w-6 h-px bg-border";

const stepIconClasses = "text-primary";

const inactiveStepIconClasses = "text-border-accent";

const Progressbar = () => {
    const { presignedUrlGenerationCount, addCaseFormStep, fromStepValue } = useAddCaseFormContext();
    const isUploading = presignedUrlGenerationCount > 0;

    const renderIcon = (index) => {
        if (index < addCaseFormStep - 1) {
            return <CompleteStepIcon className={stepIconClasses} />;
        } else if (index === addCaseFormStep - 1) {
            return <CurrentStepIcon className={stepIconClasses} />;
        } else {
            return <InactiveStepIcon className={inactiveStepIconClasses} />;
        }
    };

    return (
        <div className={stepperProgressClasses}>
            <div className='container'>
                <div className='flex items-center gap-4'>
                    <div className='flex-1 min-w-0'>
                        <div className={stepperClasses} data-tour={TOUR_TARGETS.PROGRESS_BAR}>
                            {steps.map((step, index) => (
                                <React.Fragment key={index}>
                                    <div
                                        className={`${stepClasses} ${index <= addCaseFormStep - 1 ? stepActiveClasses : ""}`}
                                    >
                                        {renderIcon(index)}
                                        <span
                                            className={isUploading ? 'cursor-not-allowed opacity-50' : 'cursor-pointer opacity-100'}
                                            onClick={() => !isUploading && fromStepValue(index + 1)}
                                        >
                                            {step}
                                        </span>
                                    </div>
                                    {index < steps.length - 1 && <div className={lineClasses}></div>}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                    <div className='flex items-center shrink-0' data-tour={TOUR_TARGETS.GENERATE_DEMAND}>
                        <GenerateDemandBtn/>
                    </div>
                </div>
            </div>
        </div>

    );
};
export default Progressbar;